import React, { useEffect, useState } from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import _isBoolean from 'lodash/isBoolean'
import { getBoundActions } from '../../../actions/index'
import { URL_CART_ACCOUNT_CREATION_CREATE, URL_CHECKOUT } from '../../../services/url/constants'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { connect as connectStaticText } from '../../StaticText/connect'
import CartProgressIndicator from '../../CartProgressIndicator/index'
import { DATA_ACTION_CONTINUE } from '../../Link/constants'
import { H1, HEADING_TYPES } from '../../Heading/index'
import Button, { TYPES } from '../../Button/index'
import CartOrderSummaryV2 from '../CartOrderSummaryV2/index'
import CartLayoutTemplate from '../CartLayoutTemplate/index'
import { requestAnimationFrame } from '../../../services/animate/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { CREATE_ACCOUNT_PRECURSOR_GA4_EVENT, ENTERED_CHECKOUT_GA4_EVENT } from '../../../services/event-tracking/index'
import OptimizelyPage from '../../OptimizelyPage/index'
import {
  shouldShowWinbackCheckout,
  WINBACK_FLAG,
  WINBACK_VARIATION,
  isWinbackFlagEnabled,
} from '../../../services/winback/index'
import OptimizelyFeature from '../../OptimizelyFeature/index'
import { historyRedirect, HISTORY_METHOD_REPLACE } from '../../../services/navigation/index'

function WinbackContent (props) {
  const {
    auth,
    history,
    userLanguage,
  } = props

  useEffect(() => {
    historyRedirect({
      history,
      url: URL_CHECKOUT,
      auth,
      language: userLanguage,
      historyMethod: HISTORY_METHOD_REPLACE,
    })
  }, [])
  return (null)
}

function CartAccountContinuePageV2 (props) {
  const {
    auth,
    user,
    paytrack,
    userAccount,
    staticText,
    setEventDefault,
    optimizelyFeature,
    sendOptimizelyFeatureEvent,
    updateOptimizelyFeatureUser,
  } = props
  // eslint-disable-next-line no-unused-vars
  const isWinbackFlagEnabledValue = isWinbackFlagEnabled(optimizelyFeature)
  const [isWinback, setIsWinback] = useState(false)
  const [renderContent, setRenderContent] = useState(false)

  function handleContinueGaEvent () {
    // GA4 event
    setEventDefault(CREATE_ACCOUNT_PRECURSOR_GA4_EVENT)
    sendOptimizelyFeatureEvent({ eventName: 'create_account_precursor' })
  }

  const renderCartOrderSummary = () => (
    <CartOrderSummaryV2 /> && (
      <div className="cart-account-continue-v2__order-summary">
        <CartOrderSummaryV2 />
      </div>
    )
  )

  useEffect(() => {
    // Winback Flow: Update the user_is_winback attribute for the winback flow
    const shouldShowWinback = shouldShowWinbackCheckout(auth, user, userAccount, paytrack)
    setIsWinback(shouldShowWinback)

    if (window.scrollTo) {
      requestAnimationFrame(() => window.scrollTo(0, 0))
    }

    // GA4 event
    setEventDefault(ENTERED_CHECKOUT_GA4_EVENT)
    sendOptimizelyFeatureEvent({ eventName: 'entered_checkout' })
  }, [])

  useEffect(() => {
    if (!_isBoolean(isWinback)) return

    updateOptimizelyFeatureUser({
      user_is_winback: isWinback,
    })
    setRenderContent(true)
  }, [isWinback])

  const header = getAuthIsLoggedIn(auth) ? 'confirmAccountDetails' : 'header'

  const renderCartContinueContent = () => {
    return (
      <div className="cart-account-continue-v2">
        <CartLayoutTemplate
          colOne={
            <React.Fragment>
              <CartProgressIndicator v2 />
              <H1 as={HEADING_TYPES.H3} className="cart-account-continue-v2__title">
                {staticText.getIn(['data', header])}
              </H1>
              <p className="cart-account-continue-v2__description">
                {staticText.getIn(['data', 'subHeader'])}
              </p>
              <Button
                className="cart-account-continue-v2__button"
                type={TYPES.PRIMARY}
                url={URL_CART_ACCOUNT_CREATION_CREATE}
                data-action={DATA_ACTION_CONTINUE}
                onClick={handleContinueGaEvent}
              >
                {staticText.getIn(['data', 'continueButtonText'])}
              </Button>
              <OptimizelyPage pageName="web_app__cart_create_account" />
            </React.Fragment>
          }
          colTwo={
            renderCartOrderSummary()
          }
        />
      </div>
    )
  }

  if (!renderContent) {
    return null
  }

  return (
    <>
      <OptimizelyFeature
        flag={WINBACK_FLAG}
        variation="control"
        isDefault={true}
        anon={false}
        noWrapper
      >
        {renderCartContinueContent()}
      </OptimizelyFeature>
      <OptimizelyFeature
        flag={WINBACK_FLAG}
        variation={WINBACK_VARIATION}
        noWrapper
      >
        <WinbackContent {...props} />
      </OptimizelyFeature>
    </>
  )
}

CartAccountContinuePageV2.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      selectedPlan: state.plans.get('selection') || Map(),
      user: state.user,
      userAccount: state.userAccount,
      paytrack: state.paytrack,
      optimizelyFeature: state.optimizelyFeature,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
        updateOptimizelyFeatureUser: actions.optimizelyFeature.updateOptimizelyFeatureUser,
      }
    },
  ),
  connectStaticText({ storeKey: 'cartAccountContinuePageV2' }),
)(CartAccountContinuePageV2)
